import socialLinks from "fragments/socialLinks"
import gql from "graphql-tag"

const outlet = gql`
  ${socialLinks}

  fragment Outlet on Outlet {
    bio
    createdAt
    domain
    id
    isPublished
    logoImageId
    name
    publishedAt
    slug
    socialLinks {
      ...SocialLinks
    }
    splashImageId
    updatedAt
    url
  }
`

export default outlet
